import { render, staticRenderFns } from "./CheckListItem.vue?vue&type=template&id=5df3d452&scoped=true&"
import script from "./CheckListItem.vue?vue&type=script&lang=js&"
export * from "./CheckListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df3d452",
  null
  
)

export default component.exports